import { Button } from 'appkit-react';

import { downloadFFIEC009Template } from '../../../../actions';
import folder from '../../../../assets/images/folder.svg';
import downloadIcon from '../../../../assets/images/download-small.svg';

const FFIEC009UploadTabTwo = () => (
    <div className="true-comply-upload__steptwo-body">
        <div className="true-comply-upload__steptwo-body-dec-section">
            <div className="true-comply-upload__steptwo-body-dec-section-left">
                <div className="true-comply-upload__steptwo-body-dec-section-left-title"> Download the sample template for uploading files </div>
                <Button
                    className="true-comply-upload__steptwo-head-right-btn"
                    onClick={() => downloadFFIEC009Template()}
                    aria-hidden="true"
                    data-testid="btn-download"
                >
                    Download
                </Button>
            </div>
            <div className="true-comply-upload__steptwo-body-dec-section-right">
                <img src={downloadIcon} alt="Download Icon" />
            </div>
        </div>
        <div className="true-comply-upload__steptwo-body-dec-section">
            <div className="true-comply-upload__steptwo-body-dec-section-left">
                <div className="true-comply-upload__steptwo-body-dec-section-left-title">  Files must be in a .xlsm format  </div>
                <p className="true-comply-upload__steptwo-body-dec-section-left-subtext">If you received the files in a .zip, please uncompress your files before uploading.</p>
            </div>
            <div className="true-comply-upload__steptwo-body-dec-section-right">
                <img src={folder} alt="Folder Icon" />
            </div>
        </div>
    </div>
);

export default FFIEC009UploadTabTwo;
